module.exports = __webpack_public_path__ + "img/iphone-charging-SWEDEN-en.4caaad63.png";